module.exports = __webpack_public_path__ + "static/media/[Annual_Oration]2014.acba9c52.md";